import { render, staticRenderFns } from "./BaseH4.vue?vue&type=template&id=d67c4f70&"
import script from "./BaseH4.vue?vue&type=script&lang=js&"
export * from "./BaseH4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports